import { render, staticRenderFns } from "./DialogAddTagConversations.vue?vue&type=template&id=0fc86dd6"
import script from "./DialogAddTagConversations.vue?vue&type=script&lang=js"
export * from "./DialogAddTagConversations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports